import { useState, useCallback, useEffect, useRef } from "react"
import { GlassTooltip } from "./GlassTooltip"
import { GlitchWord } from "./GlitchWord"
import { SCORING_CATEGORIES, type ScoringCategory } from "../lib/productTools"

function ToolItem({ tool, burstTrigger }: { tool: ScoringCategory; burstTrigger: number }) {
  const { word, icon: Icon, explainer, color, colorBase, tailwind } = tool
  const [trigger, setTrigger] = useState(0)
  const [duration, setDuration] = useState(300)

  const onOpen = useCallback(() => {
    setDuration(300)
    setTrigger(t => t + 1)
  }, [])

  useEffect(() => {
    if (burstTrigger > 0) {
      setDuration(1500)
      setTrigger(t => t + 1)
    }
  }, [burstTrigger])

  return (
    <GlassTooltip label={word} icon={Icon} explainer={explainer} color={color} onOpen={onOpen}>
      <span className="inline-flex items-center gap-1.5 whitespace-nowrap cursor-help">
        <Icon className={`w-3.5 h-3.5 shrink-0 ${tailwind.text}`} />
        <span className="text-white/70 text-sm tracking-normal">
          <GlitchWord word={word} intensity={2} externalTrigger={trigger} colorBase={colorBase} duration={duration} />
        </span>
      </span>
    </GlassTooltip>
  )
}

export function ToolGrid({ externalBurst, className }: { externalBurst?: boolean; className?: string }) {
  const [burstCount, setBurstCount] = useState(0)
  const prevBurst = useRef(false)

  useEffect(() => {
    if (externalBurst && !prevBurst.current) {
      setBurstCount(c => c + 1)
    }
    prevBurst.current = !!externalBurst
  }, [externalBurst])

  return (
    <div className={className}>
      <p className="text-base font-medium text-luster-100/95 tracking-tight leading-tight">
        One system. Every site. Live.
      </p>
      <div className="grid grid-cols-2 gap-x-6 gap-y-2 pt-1">
        {SCORING_CATEGORIES.map(tool => <ToolItem key={tool.word} tool={tool} burstTrigger={burstCount} />)}
      </div>
    </div>
  )
}
